import { Box, makeStyles } from '@material-ui/core';

import { useIberiaCardParams } from '@/components/modules/CreditCard/Detail/Overview/hooks/useIberiaCardParams';
import { ReadOnlyDataRow } from '@/components/shared/components/ReadOnlyDataRow';
import { CreditCardConfigurationType } from '@/config/types';
import { useScreen } from '@/hooks/useScreen';

interface CreditCardDisplayProps {
  creditCardConfiguration: CreditCardConfigurationType;
  size?: 'small' | 'medium';
}

export const CreditCardDisplay = ({ creditCardConfiguration, size = 'medium' }: CreditCardDisplayProps) => {
  const { sm } = useScreen();
  const { getIberiaCardParams } = useIberiaCardParams();

  const cardParams = getIberiaCardParams(creditCardConfiguration.card.type);

  if (!cardParams) {
    return (
      <Box display={'flex'} flexDirection={'column'}>
        <ReadOnlyDataRow labelTextId={'HOLDER_NAME'} value={creditCardConfiguration.holderName} />
        <ReadOnlyDataRow labelTextId={'PROVIDER'} value={creditCardConfiguration.providerName} />
        <ReadOnlyDataRow labelTextId={'BRAND'} value={creditCardConfiguration.card.brand} />
        <ReadOnlyDataRow labelTextId={'PRODUCT'} value={creditCardConfiguration.card.product} />
        <ReadOnlyDataRow labelTextId={'TYPE'} value={creditCardConfiguration.card.type} />
      </Box>
    );
  }

  const cardLink = `https://cdn.nemuru.com/assets/images/iberia-cards/${cardParams.name}.png`;

  const holderName = creditCardConfiguration.holderName ? `'${creditCardConfiguration.holderName}'` : null;

  const getParams = (size: 'small' | 'medium') => {
    if (size === 'small') {
      return {
        maxWidth: 250,
        fontSize: '0.85rem',
      };
    }
    return {
      maxWidth: 360,
      fontSize: '1.05rem',
    };
  };

  const { maxWidth, fontSize } = getParams(size);

  const styles = makeStyles(() => ({
    creditCardImageContainer: {
      position: 'relative',
      maxWidth: `${maxWidth}px`,
      ...(holderName && {
        '&::before': {
          fontSize: sm ? fontSize : '0.85rem',
          maxWidth: '69%',
          fontWeight: 500,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          content: holderName,
          position: 'absolute',
          bottom: '13.5%',
          left: '5%',
          color: cardParams?.contrastText,
          zIndex: 1,
        },
      }),
    },
  }));

  return (
    <Box minHeight={`${maxWidth * 0.633}px`}>
      <Box
        className={styles().creditCardImageContainer}
        display={'flex'}
        justifyContent={'flex-start'}
        alignItems={'flex-start'}
      >
        <img
          src={cardLink}
          alt="Logo"
          style={{
            borderRadius: '0px',
            width: '100%',
            height: 'auto',
          }}
        />
      </Box>
    </Box>
  );
};
